<template>
    <v-btn
        v-if="size==='small'"
        text
        small
        :color="color"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else-if="size==='x-small'"
        text
        x-small
        :color="color"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else-if="size==='x-large'"
        text
        x-large
        :color="color"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else-if="size==='large'"
        text
        large
        :color="color"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
    <v-btn
        v-else
        text
        :color="color"
        @click.stop="onClick()"
    >
        {{buttonText}}
    </v-btn>
</template>

<script>

export default {
    props: {
        buttonText: {
            type: String,
            default: "Click"
        },
        color: {
            type: String,
            default: "primary"
        },
        size: {
            type: String,
            default: "medium"
        }
    },
    computed: {
        
    },
    data() {
        return {
            
        };
    },
    methods: {
        onClick() {
            this.$emit('onClick');
        }
    }
};
</script>

<style>
</style>